module.exports = __webpack_public_path__ + "static/media/2.5c79f5da.mp3";